import { connect } from 'react-redux';
import { getLikertOptionColors } from 'lib/blocks';
import { TaskSummaryItem } from '.';

const LikertSummaryQuestion = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  ({
    answers,
    colormap,
    messages,
    options,
    question,
    questionAverages,
    questionResponseRates,
    reset,
    shouldShowPercentage,
    taskId,
    theme
  }) => {
    const likertOptionColors = getLikertOptionColors({
      colormapType: colormap,
      numberOfColors: options?.length || 0,
      theme
    });

    return (
      <div className="question">
        <div className="question-content">
          <div
            className="question-content-inner"
            dangerouslySetInnerHTML={{ __html: question.question }}
          />

          {answers.length ? (
            <div className="question-average">
              <TaskSummaryItem
                style={{ marginRight: 0 }}
                tooltip={messages.tasksAverageScore}
                value={questionAverages[question.id] || '–'}
              />
            </div>
          ) : null}
        </div>

        <div className="percentage">
          {options.map((option, j) => {
            return questionResponseRates[question.id][j] > 0 ? (
              <div
                className="percentage-bar"
                key={j}
                data-tooltip={`${j + 1}. ${option}: ${Math.round(
                  questionResponseRates[question.id][j]
                )} %`}
                style={{
                  width: `${questionResponseRates[question.id][j]}%`
                }}
              >
                <div
                  className="percentage-bar-background"
                  style={{
                    backgroundColor: likertOptionColors[j].backgroundColor
                  }}
                />
                <div
                  className="percentage-bar-label"
                  id={`percentage-bar-label-${taskId}-${question.id}-${j}`}
                  style={{ color: likertOptionColors[j].color }}
                >
                  {reset && shouldShowPercentage(question.id, j)
                    ? `${Math.round(questionResponseRates[question.id][j])} %`
                    : null}
                </div>
              </div>
            ) : null;
          })}
        </div>

        <style jsx>{`
          .question {
            background-color: white;
            border-radius: ${theme.cardBorderRadius};
            margin-top: 10px;
            padding: 10px 15px;
          }
          .question-content {
            align-items: top;
            color: ${theme.textColor};
            display: flex;
            font-size: 1.5rem;
          }
          .question-content::before {
            counter-increment: likert-questions;
            content: counter(likert-questions) '.';
            display: inline-block;
            margin-right: 5px;
          }
          .question-content-inner {
            flex-grow: 1;
            min-width: 0;
          }
          .question-content-inner :global(p) {
            margin: 10px 0 0;
          }
          .question-content-inner :global(p:first-child) {
            margin-top: 0;
          }
          .question-average {
            margin-left: 20px;
          }
          .percentage {
            border-radius: 30px;
            display: flex;
            flex-direction: row;
            font-size: 1.3rem;
            margin-top: 15px;
            overflow: hidden;
            width: 100%;
          }
          .percentage-bar {
            height: 19px;
            overflow: hidden;
            position: relative;
          }
          .percentage-bar:first-child {
            border-radius: 30px 0 0 30px;
          }
          .percentage-bar:last-child {
            border-radius: 0 30px 30px 0;
          }
          .percentage-bar:not(:first-child) {
            border-left: 1px solid white;
          }
          .percentage-bar-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
          .percentage-bar-label {
            font-weight: 600;
            position: absolute;
            top: 1px;
            left: 5px;
            right: 5px;
            bottom: 1px;
            z-index: 1;
          }
        `}</style>
      </div>
    );
  }
);

export default LikertSummaryQuestion;
